import { Get } from "../http/httpVerbs";

export const apiGetComunidadeStats = async (comunidade, filters = {}) => {
    try {
        let url = `${process.env.REACT_APP_API_URL}/posts/stats`;
        let isFirstParam = true;

        if (comunidade) {
            url += `${isFirstParam ? "?" : "&"}comunidade=${comunidade}`;
            isFirstParam = false;
        }

        if (filters.dataInicio) {
            url += `${isFirstParam ? "?" : "&"}dataInicio=${filters.dataInicio}`;
            isFirstParam = false;
        }

        if (filters.dataFim) {
            url += `${isFirstParam ? "?" : "&"}dataFim=${filters.dataFim}`;
            isFirstParam = false;
        }

        const response = await Get(url);

        return response;
    } catch (error) {
        console.error("API apiGetComunidadeStats ERROR:", error);
        throw error;
    }
};
